import { render, staticRenderFns } from "./XPorterLeaverServiceSettings.vue?vue&type=template&id=4f6d6314&"
import script from "./XPorterLeaverServiceSettings.vue?vue&type=script&lang=ts&"
export * from "./XPorterLeaverServiceSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports